import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import { debounce } from 'lodash';
import { changeTextProperty } from '../../../redux/actions/entities/texts';

class FontColor extends Component {
  constructor(...args) {
    super(...args);
    this.state = ({
      displayColorPicker: false,
      color: '#000',
    });
    this.handleColorChange = debounce(this.handleColorChange, 500);
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    const { hex } = color;
    this.setState({ color: hex });
    this.handleColorChange(hex);
  };

  handleColorChange = (hex) => {
    const { textFieldId } = this.props;
    this.props.dispatch(changeTextProperty(textFieldId, 'color', hex));
  }

  handleBlur = () => {
    this.setState({ displayColorPicker: false });
  }

  render() {
    const {
      color,
      displayColorPicker,
    } = this.state;

    const { color: fontColor } = this.props;
    const selectedColor = !displayColorPicker ? fontColor : color;
    const selectedColorStyle = {
      backgroundColor: selectedColor,
    };

    const styles = {
      default: {
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
      },
    };


    return (
      <div className="col color textToolsIcon" >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 13 14"
          enableBackground="new 0 0 13 14"
          style={{
            width: '14px',
            height: '13px',
            marginRight: '11px',
            position: 'relative',
            top: '3px',
            left: '2px',
          }}
        >
          <polygon fill="#555555" points="0,0 0,4 2,4 2,2 5,2 5,12 3,12 3,14 10,14 10,12 8,12 8,2 11,2 11,4 13,4 13,0 " />
        </svg>

        <input type="text" value={selectedColor} onChange={() => {}}className="fontColor" />
        <div
          style={selectedColorStyle}
          className="selected-color"
          onClick={this.handleClick}
          onKeyUp={() => {}}
          role="button"
          tabIndex="0"
        />
        { displayColorPicker ?
          <div style={styles.popover} onMouseLeave={this.handleBlur}>
            <SketchPicker
              color={selectedColor}
              onChange={this.handleChange}
            />
          </div> : null }
      </div>
    );
  }
}

FontColor.defaultProps = {
  textFieldId: 0,
  color: '#fff',
};

FontColor.propTypes = {
  textFieldId: PropTypes.number,
  color: PropTypes.string,
};

export default connect()(FontColor);



// WEBPACK FOOTER //
// ./src/components/text-tools/font-color/FontColor.jsx